import { createAPIActions } from 'barnyard/utils';

export const NAME = 'CORE';
export const APP_URL = 'corporate';
export const RESET_DATA = `${NAME}/RESET_DATA`;

export const PROFILE_FETCH_SUCCESS = `${NAME}/PROFILE_FETCH_SUCCESS`;
export const CORPORATE_FETCH_SUCCESS = `${NAME}/CORPORATE_FETCH_SUCCESS`;
export const SUPPLIERS_FETCH_SUCCESS = `${NAME}/SUPPLIERS_FETCH_SUCCESS`;
export const MANUFACTURERS_FETCH_SUCCESS = `${NAME}/MANUFACTURERS_FETCH_SUCCESS`;
export const MANUFACTURERS_SEARCH_SUCCESS = `${NAME}/MANUFACTURERS_SEARCH_SUCCESS`;
export const PRODUCTS_SEARCH_SUCCESS = `${NAME}/PRODUCTS_SEARCH_SUCCESS`;
export const CATEGORIES_FETCH_SUCCESS = `${NAME}/CATEGORIES_FETCH_SUCCESS`;

// Corporate User
export const CORPORATE_USER_FETCH_SUCCESS = `${NAME}/CORPORATE_USER_FETCH_SUCCESS`;
export const CORPORATE_USER_UPDATE = createAPIActions(`${NAME}/CORPORATE_USER_UPDATE`);

// Corporate regions
export const CORPORATE_REGIONS_FETCH_SUCCESS = `${NAME}/CORPORATE_REGIONS_FETCH_SUCCESS`;
export const CORPORATE_REGION_CREATE_REQUEST = `${NAME}/CORPORATE_REGION_CREATE_REQUEST`;
export const CORPORATE_REGION_CREATE_SUCCESS = `${NAME}/CORPORATE_REGION_CREATE_SUCCESS`;
export const CORPORATE_REGION_CREATE_FAILURE = `${NAME}/CORPORATE_REGION_CREATE_FAILURE`;
export const CORPORATE_REGION_UPDATE_REQUEST = `${NAME}/CORPORATE_REGION_UPDATE_REQUEST`;
export const CORPORATE_REGION_UPDATE_SUCCESS = `${NAME}/CORPORATE_REGION_UPDATE_SUCCESS`;
export const CORPORATE_REGION_UPDATE_FAILURE = `${NAME}/CORPORATE_REGION_UPDATE_FAILURE`;
export const CORPORATE_REGION_DELETE_REQUEST = `${NAME}/CORPORATE_REGION_DELETE_REQUEST`;
export const CORPORATE_REGION_DELETE_SUCCESS = `${NAME}/CORPORATE_REGION_DELETE_SUCCESS`;
export const CORPORATE_REGION_DELETE_FAILURE = `${NAME}/CORPORATE_REGION_DELETE_FAILURE`;

// Corporate
export const CORPORATE_DATA_SETTINGS_UPDATE = createAPIActions(`${NAME}/CORPORATE_DATA_SETTINGS_UPDATE`);
export const CORPORATE_DATA_SETTINGS_FETCH = createAPIActions(`${NAME}/CORPORATE_DATA_SETTINGS_FETCH`);
export const CORPORATE_FORM_NAME = 'corporate';

// Buyer Fetches
export const BUYERS_FETCH_SUCCESS = `${NAME}/BUYERS_FETCH_SUCCESS`;
export const BUYER_FETCH_SUCCESS = `${NAME}/BUYER_FETCH_SUCCESS`;
export const BUYER_UPDATE_REQUEST = `${NAME}/BUYER_UPDATE_REQUEST`;
export const BUYER_UPDATE_SUCCESS = `${NAME}/BUYER_UPDATE_SUCCESS`;

// Profile actions
export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST';
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS';
// Product Lines
export const PRODUCT_LINES_FETCH = createAPIActions(`${NAME}/PRODUCT_LINES_FETCH`);
// GL Codes
export const GL_CODES_FETCH = createAPIActions(`${NAME}/GL_CODES_FETCH`);
export const GL_CODE_CREATE = createAPIActions(`${NAME}/GL_CODE_CREATE`);
export const GL_CODE_DELETE = createAPIActions(`${NAME}/GL_CODE_DELETE`);
export const GL_CODE_UPDATE = createAPIActions(`${NAME}/GL_CODE_UPDATE`);

export const CategoryLevel = {SECONDARY: 'secondary', PRIMARY: 'primary'}
